import React, { useEffect, useState, useRef } from 'react'
import SolicitacaoService from "../../../services/SolicitacaoService"
import SolicitacaoBox from '../../../components/data_display/SolicitacaoBox'
import { ComunicacoesBox } from './styles'
import { useSnackbar } from "notistack"
import { useReactToPrint } from 'react-to-print';
import LogoTce from '../../../assets/img/logo-tcego.svg'
import { isNullReturnHyphen, DateFormat } from "../../../functions"
import Paginacao from '../../../components/data_display/Paginacao'
import { useAuth } from 'react-oidc-context'
import webconfig from "../../../webconfig.json"

export default function SolicitacoesTriagem(
    etapaSolicitacaoAcesso,
    titulo,
    recarregarTriagens,
    setRecarregarTriagens
) {
    const auth = useAuth()

    const [pagina, setPagina] = useState(1)
    const [qtdePagina, setQtdePagina] = useState(5)
    const [totalPagina, setTotalPagina] = useState(1)
    const [solicitacoes, setSolicitacoes] = useState([])

    const [solicitacoesPrint, setSolicitacoesPrint] = useState([])

    const [loadingCsv, setLoadingCsv] = useState(false)
    const [loadingPdf, setLoadingPdf] = useState(false)
    const { enqueueSnackbar } = useSnackbar()

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Visitor Pass'
    });

    const getSolicitacoes = async () => {
        SolicitacaoService.ConsultaTriagemPorSituacao(etapaSolicitacaoAcesso, pagina, qtdePagina)
            .then(response => {
                setSolicitacoes(response.data.solicitacoes)
                setTotalPagina(response.data.totalPaginas)
            })
            .catch(error => {
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const exportaCsv = () => {
        setLoadingCsv(true)
        SolicitacaoService.ExportaCsv(etapaSolicitacaoAcesso)
            .then(response => {
                if (response.status === 200) {
                    let extensionFile = response.data.tipoArquivo
                    let a = document.createElement("a")
                    a.href = `data:${extensionFile};base64,${response.data.conteudo}`
                    a.download = response.data.nomeArquivo
                    a.click()

                    enqueueSnackbar('Download realizado com sucesso', { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoadingCsv(false)
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do arquivo CSV. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoadingCsv(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const exportPdf = () => {
        SolicitacaoService.ConsultaTriagemPorSituacao(etapaSolicitacaoAcesso, 1, 1000000)
            .then(response => {
                setSolicitacoesPrint(response.data.solicitacoes)
                handlePrint()
            })
            .catch(error => {
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    useEffect(() => {
        getSolicitacoes()
    }, [pagina, qtdePagina, recarregarTriagens])

    class ComunicacaoPrint extends React.Component {
        render() {
            return (
                <ComunicacoesBox.PrintPage className="" >
                    <div style={{ textAlign: "center", paddingTop: "30px" }}><img src={LogoTce} alt="" /></div>
                    <div style={{ textAlign: "center", fontSize: "24px" }}><span>Tribunal de Contas do Estado de Goiás</span></div>
                    <div style={{ textAlign: "center", padding: "10px" }}><span>Solicitações {titulo}</span></div>
                    <div style={{ fontSize: "12px" }}>
                        <div style={{ display: "inline" }}>
                            <span>Usuário:</span>
                            <span style={{ paddingLeft: "5px" }}>{auth.user?.profile.name}</span>
                        </div>
                        <div style={{ display: "inline", float: "right" }}>
                            <span>Data:</span>
                            <span style={{ paddingLeft: "5px" }}>{isNullReturnHyphen(DateFormat(new Date()))}</span>
                        </div>
                    </div>
                    <ComunicacoesBox.PrintHeader>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Data da Soliciação</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Nome</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>CPF</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>e-mail</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Telefone</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Situação</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Órgão Jurisdicionado</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Usuário Triagem</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{solicitacoesPrint.length > 0 && solicitacoesPrint[0].situacao === 0 ? 'Data Triagem' : 'Data Deferimento'}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Data Revogação</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                        <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>Motivo Negativa/Revogação</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                    </ComunicacoesBox.PrintHeader>
                    <ComunicacoesBox.PrintBody>
                        {solicitacoesPrint.length > 0 && solicitacoesPrint.map((solicitacao) => (
                            <ComunicacoesBox.PrintBodyLine>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(DateFormat(solicitacao.dataSolicitacao))}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.usuario?.nome)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.usuario?.cpf)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.usuario?.email)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.usuario?.telefone)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.situacaoTexto)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.nomeOrgaoJurisdicionado)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.nomePessoaDoUsuarioTriagem)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(DateFormat(solicitacao.dataTriagem))}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(DateFormat(solicitacao.dataRevogacao))}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                                <ComunicacoesBox.PrintColumn><ComunicacoesBox.CellInformacao>{isNullReturnHyphen(solicitacao.motivoNegativa)}</ComunicacoesBox.CellInformacao></ComunicacoesBox.PrintColumn>
                            </ComunicacoesBox.PrintBodyLine>
                        ))
                        }
                    </ComunicacoesBox.PrintBody>
                </ComunicacoesBox.PrintPage >
            )
        }
    }

    return (
        <>
            {(solicitacoes.length > 0 || totalPagina > 1 || pagina > 1) && (
                <Paginacao
                    pagina={pagina}
                    qtdePagina={qtdePagina}
                    totalPagina={totalPagina}
                    setPagina={setPagina}
                    setQtdePagina={setQtdePagina}
                    exportaCsv={() => exportaCsv()}
                    exportPdf={() => exportPdf()}
                    loadingCsv={loadingCsv}
                    loadingPdf={loadingPdf}
                />
            )}

            {solicitacoes.length > 0 || totalPagina > 1 ? solicitacoes.map((item) => (
                <SolicitacaoBox
                    solicitacao={item}
                    setRecarregarTriagens={(value) => setRecarregarTriagens(value)}
                    etapaSolicitacaoAcesso={etapaSolicitacaoAcesso}
                />
            )) : <p>Nenhuma comunicação para esse item.</p>
            }

            {(solicitacoes.length > 0 || totalPagina > 1 || pagina > 1) && (
                <Paginacao
                    pagina={pagina}
                    qtdePagina={qtdePagina}
                    totalPagina={totalPagina}
                    setPagina={setPagina}
                    setQtdePagina={setQtdePagina}
                    exportaCsv={() => exportaCsv()}
                    exportPdf={() => exportPdf()}
                    loadingCsv={loadingCsv}
                    loadingPdf={loadingPdf}
                />
            )}

            <div style={{ display: "none" }}>
                <ComunicacaoPrint ref={componentRef} />
            </div>
        </>
    )
}